import { getAppointmentMenuItem } from './AppointmentMenuItem';
import { getGetCare } from './GetCare.js';
import { getInsuranceAndBilling } from './InsuranceAndBilling.js';
import { getInBox } from './InBox.js';
import { getProfileMenuItems } from './Profile.js';
import { getBSWPharmacy } from './BSWPharmacy.js';
import { getSettingMenuItems } from './SettingMenuItems.js';
import { getSignOutMenuItem } from './SignOutMenuItem.js';
import { getWellness } from './Wellness.js';

// Sign out menu item for sub menus
const signOutItem = {
    show: true,
    label: 'Sign Out',
    url: null,
    className: 'sign-out-link'
};

export function getSiteMenuItems(props, state) {
    const {
        authorizedFeaturesProps,
        bundle,
        disableMyChartMenuItems,
        isMyChartProxyUser,
        isMyChartUser,
        isPrimaryUser,
        notPharmacyProxy,
        aalDown,
        canAccessThrive,
        communitySupportBanned,
        Covid19AgeForVaccine,
        currentPharmacyUser,
        currentUser,
        dentalInvoice,
        enableCareCompanion,
        enableHappyTogether,
        enablePrayerFeature,
        enablePricingTransparency,
        EnableProfileDashboard,
        enableInHomeFeature,
        epicEHRDown,
        hasAAL,
        hasFirstCare,
        hasHealthPlanLogin,
        hasMyChart,
        hasPharmacyLogin,
        hpIdentity,
        isMedicalAdvice,
        insuranceTabText,
        isActiveFeature_Amity,
        isActiveFeature_InsuranceModule,
        isEmployee,
        isMemberPayer,
        isMyChartInActive,
        rxDown,
        swhp,
        swhpDown,
        removeBSWPharmacy
    } = props;

    return [
        addSignOutToSubMenus(getGetCare({
            disableMyChartMenuItems,
            enableInHomeFeature,
            notPharmacyProxy,
            isMyChartUser,
            isPrimaryUser
        })),
        addSignOutToSubMenus(getAppointmentMenuItem({
            disableMyChartMenuItems,
            isMyChartUser,
        })),
        addSignOutToSubMenus(getInBox({
            disableMyChartMenuItems,
            isMedicalAdvice,
            isMyChartUser
        })),
        addSignOutToSubMenus(getInsuranceAndBilling({
            aalDown,
            disableMyChartMenuItems,
            enablePricingTransparency,
            epicEHRDown,
            dentalInvoice,
            hasAAL,
            hasFirstCare,
            hasHealthPlanLogin,
            hasMyChart,
            hpIdentity,
            insuranceTabText,
            isActiveFeature_InsuranceModule,
            isEmployee,
            isMemberPayer,
            isMyChartInActive,
            isMyChartProxyUser,
            isMyChartUser,
            isPrimaryUser,
            notPharmacyProxy,
            swhp,
            swhpDown
        })),
        addSignOutToSubMenus(getProfileMenuItems({
            authorizedFeaturesProps,
            Covid19AgeForVaccine,
            currentPharmacyUser,
            currentUser,
            disableMyChartMenuItems,
            EnableProfileDashboard,
            hasAAL,
            hasFirstCare,
            hasHealthPlanLogin,
            hasMyChart,
            hasPharmacyLogin,
            isMyChartProxyUser,
            isMyChartUser,
            isPrimaryUser,
            notPharmacyProxy
        })),
        addSignOutToSubMenus(getWellness({
            authorizedFeaturesProps,
            canAccessThrive,
            communitySupportBanned,
            disableMyChartMenuItems,
            enableCareCompanion,
            enablePrayerFeature,
            isActiveFeature_Amity,
            isEmployee,
            isMyChartUser,
            isPrimaryUser,
            notPharmacyProxy,
        })),
        addSignOutToSubMenus(getBSWPharmacy({
            bundle,
            currentPharmacyUser,
            hasPharmacyLogin,
            isMyChartProxyUser,
            rxDown,
            removeBSWPharmacy
        })),
        addSignOutToSubMenus(getSettingMenuItems({
            disableMyChartMenuItems,
            enableHappyTogether,
            isMyChartUser,
            isPrimaryUser,
            notPharmacyProxy
        })),
        getSignOutMenuItem()
    ];
}

const addSignOutToSubMenus = (navItem) => {
    navItem.navItems.forEach(ni => {
        if (ni.subMenuItems && ni.subMenuItems.menuItems && ni.subMenuItems.menuItems.length > 0) {
            ni.subMenuItems.menuItems.push(signOutItem);
        }
    });
    return navItem;
}
